import { createContext } from "react";

/**
 * Shape of the authentication token context value.
 * Exposes the current auth token or null when the user is not authenticated.
 */
export interface AuthTokenContextValue {
  /**
   * The current authentication token, or null if not authenticated.
   */
  readonly authToken: string | null;
}

/**
 * Context for providing authentication tokens to data source hooks.
 * This allows useRemoteTableDataSource and similar hooks to automatically
 * include Authorization headers without requiring explicit authToken props.
 *
 * This context is defined in capitalrx-shell-auth (rather than capitalrx-components-2.0)
 * to ensure a single shared instance when used across the shell and federated modules.
 *
 * Note: For backward compatibility, this is re-exported from capitalrx-components-2.0/lib/general.
 * New code should import directly from capitalrx-shell-auth.
 *
 * @see {@link AuthTokenProvider} for the provider component
 * @see {@link useAuthTokenContext} for the consumer hook
 */
export const AuthTokenContext = createContext<AuthTokenContextValue>({
  authToken: null,
});

AuthTokenContext.displayName = "AuthTokenContext";
